import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const ARRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnTillgang,
  rutinInfos.rtnVisaInvestering,
  rutinInfos.rtnVerifikation,
];

export default ARRutinMeny;
